import React, { FC, PropsWithChildren, useCallback, useEffect, useRef } from 'react';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onClickOutside: () => void;
}

export const WithClickOutside: FC<PropsWithChildren<Props>> = (props: Props) => {
  const { children, onClickOutside, ...restProps } = props;
  const ref = useRef<HTMLDivElement>(null);

  const handleClickInOrOutside = useCallback((event: MouseEvent) => {
    const path = event.composedPath();
    const withinBoundaries = ref.current !== null && path.includes(ref.current);

    if (!withinBoundaries) {
      onClickOutside();
    }
  }, [onClickOutside]);

  /* Capture phase so this runs before Modal `Overflow` stops propagation on bubble (see `atoms/modal.tsx`). */
  useEffect(() => {
    document.addEventListener('click', handleClickInOrOutside, true);
    return () => document.removeEventListener('click', handleClickInOrOutside, true);
  }, [handleClickInOrOutside]);

  return (
    <div ref={ref} {...restProps}>
      {children}
    </div>
  );
};
